import React, { ReactNode, useEffect, useState } from 'react';
import useEnhancedAuth from './EnhancedAuth';
import { appIsOnline } from './utils/nav';
import { IonContent, IonPage } from '@ionic/react';
import AppOffline from './components/AppOffline';
import AppLoading from './components/AppLoading';
import { useTranslation } from 'react-i18next';
import { startRefreshTokenTimeout } from './services/apiHandler';

type Props = { children?: ReactNode };

export const PrivateRoute = ({ children }: Props) => {
  const { isLoading, isAuthenticated } = useEnhancedAuth();
  const [t] = useTranslation('global');

  const [isOffline, setIsOffline] = useState<boolean>(false);

  useEffect(() => {
    appIsOnline().then((online) => {
      if (!online) {
        setIsOffline(true);
      }
    });
  }, []);

  useEffect(() => {
    console.log('Auth Updated', isLoading, isAuthenticated);
  }, [isLoading, isAuthenticated]);

  if (!isAuthenticated) {
    
    startRefreshTokenTimeout();

    return (
      <IonPage>
        <IonContent fullscreen className="ion-padding">
          <div className="ion-text-center">
            <p className="instructions pb-4">{t('home.autherror')}</p>
          </div>
        </IonContent>
      </IonPage>
    );
  }

  if (isLoading) {
    return (
      <IonPage>
        <IonContent fullscreen className="ion-padding">
          <AppLoading hidden={false} />
        </IonContent>
      </IonPage>
    );
  }

  if (isOffline) {
    return (
      <IonPage>
        <IonContent fullscreen className="ion-padding">
          <AppOffline />
        </IonContent>
      </IonPage>
    );
  }

  return <>{children}</>;
};
